module.exports = __webpack_public_path__ + "10f72f5e7f7eb9fb52e1a0ba902d6c6c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/chef-jacket-s.png
// module id = 1871
// module chunks = 0